import type { GetPropertyOwnerListParams } from '../types/propertyOwnerTypes'

export const ownersQueryKeys = {
  all: ['propertyOwners', 'owners'] as const,
  lists: () => ['propertyOwners', 'owners', 'list'] as const,
  list: (params: GetPropertyOwnerListParams) =>
    ['propertyOwners', 'owners', 'list', params] as unknown[],
  details: (id: string) => ['propertyOwners', 'owners', 'details', id] as const,
  lookup: () => ['propertyOwners', 'owners', 'lookup'] as const,
  withBankAccounts: () => ['propertyOwners', 'owners', 'withBankAccounts'] as const,
  bankAccountsLookup: (ownerId: string) =>
    ['propertyOwners', 'owners', 'bankAccounts', ownerId] as const,
  complianceProfile: (ownerId: string) =>
    ['propertyOwners', 'owners', 'complianceProfile', ownerId] as const,
  onboardingChecks: (ownerId: string) =>
    ['propertyOwners', 'owners', 'onboardingChecks', ownerId] as const,
  kycLists: () => ['propertyOwners', 'owners', 'kyc', 'list'] as const,
  kycList: (params: unknown) => ['propertyOwners', 'owners', 'kyc', 'list', params] as const,
  bankAccountAdminLists: () => ['propertyOwners', 'owners', 'bankAccountsAdmin', 'list'] as const,
  bankAccountAdminList: (params: unknown) =>
    ['propertyOwners', 'owners', 'bankAccountsAdmin', 'list', params] as const,
  bankAccountStatusCounts: () =>
    ['propertyOwners', 'owners', 'bankAccountsAdmin', 'statusCounts'] as const,
  bankAccountDetail: (id: string) =>
    ['propertyOwners', 'owners', 'bankAccountsAdmin', 'detail', id] as const,
  vaspLists: () => ['propertyOwners', 'owners', 'vasp', 'list'] as const,
  vaspList: (params: unknown) => ['propertyOwners', 'owners', 'vasp', 'list', params] as const,
  vaspDetail: (id: string) => ['propertyOwners', 'owners', 'vasp', 'detail', id] as const,
  vaspStatusCounts: () => ['propertyOwners', 'owners', 'vasp', 'statusCounts'] as const,
  // Counts for the 4 VASP queue filter cards (all/pending/active/rejected).
  vaspQueueStatusCounts: () =>
    ['propertyOwners', 'owners', 'vasp', 'queueStatusCounts'] as const,
  onboardingReviewLists: () => ['propertyOwners', 'owners', 'onboardingReview', 'list'] as const,
  onboardingReviewList: (params: unknown) =>
    ['propertyOwners', 'owners', 'onboardingReview', 'list', params] as const,
  kycDocumentsLists: (ownerId: string) =>
    ['propertyOwners', 'owners', 'kycDocuments', ownerId] as const,
  kycDocumentsPage: (ownerId: string, page: number, limit: number) =>
    ['propertyOwners', 'owners', 'kycDocuments', ownerId, { page, limit }] as const,
  complianceActivityLists: (ownerId: string) =>
    ['propertyOwners', 'owners', 'complianceActivity', ownerId] as const,
  complianceActivityPage: (ownerId: string, page: number, limit: number) =>
    ['propertyOwners', 'owners', 'complianceActivity', ownerId, { page, limit }] as const,
  companyProfile: (ownerId: string) =>
    ['propertyOwners', 'owners', 'companyProfile', ownerId] as const,
  onboardingPipelineRow: (email: string) =>
    ['propertyOwners', 'owners', 'onboardingPipeline', 'row', email] as const,
  complianceKycPage: (ownerId: string, page: number, limit: number) =>
    ['propertyOwners', 'owners', 'compliance', 'kyc', ownerId, { page, limit }] as const,
  kycDocumentSignedUrl: (ownerId: string, docId: string) =>
    ['propertyOwners', 'owners', 'kycDocument', 'signedUrl', ownerId, docId] as const,
  complianceAmlPage: (ownerId: string, page: number, limit: number) =>
    ['propertyOwners', 'owners', 'compliance', 'aml', ownerId, { page, limit }] as const,
  compliancePepPage: (ownerId: string, page: number, limit: number) =>
    ['propertyOwners', 'owners', 'compliance', 'pep', ownerId, { page, limit }] as const,
}
